import {
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DatePicker from "@mui/lab/DatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useHistory, useParams, useLocation } from "react-router-dom";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import moment from "moment";
import { Formik, useFormik } from "formik";
import * as yup from "yup";
import { get } from "lodash";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function EditService() {
  const EmpId = localStorage.getItem("EmpId");
  const history = useHistory();
  let { id } = useParams();
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [Submitting, setSubmitting] = useState(false);
  const [serviceNo, setServiceNo] = useState(null);
  const [serviceName, setServiceName] = useState(null);
  const [ContainerList, setContainerList] = useState([]);
  const [LocationList, setLocationList] = useState([]);
  const [GroupList, setGroupList] = useState([]);
  const [Status, setStatus] = useState(true);
  const [Amount, setAmount] = useState("");
  const [ContainerId, setContainerId] = useState("");
  const [ContainerName, setContainerName] = useState("");
  const [DetailList, setDetailList] = useState([]);
  const [SUM, setSUM] = useState("");

  const validationSchema = yup.object({
    ServiceName: yup
      .string("Enter your ServiceName")
      .required("ServiceName is required"),
    locationFrom: yup
      .string("Select locationFrom")
      .required("locationFrom is required"),
    groupFrom: yup.string("Select groupFrom").required("groupFrom is required"),
    locationTo: yup
      .string("Select locationTo")
      .required("locationTo is required"),
    groupTo: yup.string("Select groupTo").required("groupTo is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      ServiceName: "",
      ServiceNo: '',
      // locationFrom: "",
      // groupFrom: "",
      // locationTo: "",
      // groupTo: "",
      // containerId: "",
      // priceDate: "",
      // amount: "",
    },
    validationSchema: validationSchema,

    onSubmit: (values) => {
      console.log('first')
      setSubmitting(true);
      const data = {
        ServiceName: values.ServiceName,
        ServiceId: null,
        // from: values.locationFrom,
        // groupFrom: values.groupFrom,
        // to: values.locationTo,
        // groupTo: values.groupTo,
        // priceDate: !values.priceDate
        //   ? moment(new Date()).format("YYYY-MM-DD")
        //   : moment(values.priceDate).format("YYYY-MM-DD"),
        // typeId: values.containerId,
        Status: Status,
        // createId: EmpId,
        // amount: SUM,
        // detail: DetailList.filter((x) => x.Delete === false).map((x) => ({
        //   containerId: x.ContainerId,
        //   amount: x.Amount,
        // })),
      };
      const dataUpdate = {
        ServiceId: id,
        ServiceName: values.ServiceName,
        // from: values.locationFrom,
        // groupFrom: values.groupFrom,
        // to: values.locationTo,
        // groupTo: values.groupTo,
        // priceDate: !values.priceDate
        //   ? moment(new Date()).format("YYYY-MM-DD")
        //   : moment(values.priceDate).format("YYYY-MM-DD"),
        // typeId: values.containerId,
        Status: Status,
        // createId: EmpId,
        // amount: SUM,
        // detail: DetailList.filter((x) => x.Delete === false).map((x) => ({
        //   containerId: x.ContainerId,
        //   amount: x.Amount,
        // })),
      };
      setTimeout(() => {
        if (id) {
          api
            .post("api/service/update", dataUpdate)
            .then((respose) => {
              const MySwal = withReactContent(Swal);

              MySwal.fire({
                icon: "success",
                didOpen: () => {
                  MySwal.clickConfirm();
                },
              }).then(() => {
                return MySwal.fire(
                  "สำเร็จ!",
                  "แก้ไขบริการสำเร็จ !",
                  "success"
                ).then((result) => {
                  if (result.isConfirmed) {
                    history.push("/Setting/Service");
                  }
                });
              });
              console.log(respose);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          api
            .post("api/service/create", data)
            .then((respose) => {
              const MySwal = withReactContent(Swal);

              MySwal.fire({
                icon: "success",
                didOpen: () => {
                  MySwal.clickConfirm();
                },
              }).then(() => {
                return MySwal.fire(
                  "สำเร็จ!",
                  "เพิ่มบริการสำเร็จ !",
                  "success"
                ).then((result) => {
                  if (result.isConfirmed) {
                    history.push("/Setting/Service");
                  }
                });
              });
              console.log(respose);
            })
            .catch((err) => {
              console.log(err);
            });

        }

        setSubmitting(false);
      }, 400);
    },
  });

  // const getContainerList = async () => {
  //   try {
  //     const result = await api.get("api/container/list");
  //     const _result = result.data;
  //     setContainerList(_result);
  //   } catch (error) {
  //     console.log("error => ", error);
  //   }
  // };

  // const getLocationList = async () => {
  //   try {
  //     const result = await api.get("api/master/location");
  //     const _result = result.data.data;
  //     setLocationList(_result);
  //   } catch (error) {
  //     console.log("error => ", error);
  //   }
  // };

  // const getGroupList = async () => {
  //   try {
  //     const result = await api.get("api/master/group");
  //     const _result = result.data.data;
  //     setGroupList(_result);
  //   } catch (error) {
  //     console.log("error => ", error);
  //   }
  // };

  const getServiceDetail = async () => {
    // console.log('first')
    try {
      await api
        .post("api/service/detail", { ServiceId: id })
        .then((res) => {
          if (res) {
            console.log(res.data)
            setStatus(res.data.Status);
            setServiceName(res.data.ServiceName);
            setServiceNo(res.data.ServiceNo);
            // formik.setFieldValue("locationFrom", res.data[0].LocationFrom);
            // formik.setFieldValue("groupFrom", res.data[0].GroupFrom);
            // formik.setFieldValue("locationTo", res.data[0].LocationTo);
            // formik.setFieldValue("groupTo", res.data[0].GroupTo);
            // formik.setFieldValue("priceDate", res.data[0].PriceDate);
            // formik.setFieldValue("containerId", res.data[0].ContainerTypeId);
            // formik.setFieldValue("amount", res.data[0].Amount);

            // setDetailList(
            //   res.data[0]?.Detail?.map((x) => ({
            //     ...x,
            //     Delete: false,
            //   }))
            // );

            // const sum = res.data[0].Detail?.map((item) => item.Amount).reduce(
            //   (prev, cur) => {
            //     // prev = 0 [1,2,3] index = 0
            //     return prev + parseInt(cur, 10);
            //   },
            //   0
            // );

            // setSUM(sum);
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/Service");
                }
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };

  // const handleSaveDialog = () => {
  //   const rowDetail = [
  //     ...DetailList,
  //     {
  //       ContainerId: ContainerId,
  //       ContainerTypeName: ContainerName,
  //       Amount: Amount,
  //       Delete: false,
  //       id: DetailList.length + 1,
  //     },
  //   ];

  //   const sum = rowDetail
  //     .filter((x) => !x.Delete)
  //     .map((item) => item.Amount)
  //     .reduce((prev, cur) => {
  //       // prev = 0 [1,2,3] index = 0
  //       return prev + parseInt(cur, 10);
  //     }, 0);

  //   setDetailList(rowDetail);
  //   setSUM(sum);

  //   handleCloseDialog();
  // };

  // const handleCloseDialog = () => {
  //   setOpen(false);
  //   setContainerName("");
  //   setAmount("");
  //   setContainerId("");
  // };

  // const handleDeleteRow = (data, index) => {
  //   const _RowList = DetailList.map((item, index2) =>
  //     data.id === item.id
  //       ? {
  //         ...item,
  //         Delete: true,
  //       }
  //       : item
  //   );
  //   const RowList = _RowList.filter((x) => x.Delete === false);
  //   const sum = RowList.map((item) => item.Amount).reduce((prev, cur) => {
  //     // prev = 0 [1,2,3] index = 0
  //     return prev + parseInt(cur, 10);
  //   }, 0);

  //   setSUM(sum);

  //   setDetailList(RowList);
  // };

  const isError = (fieldName) => {
    return (
      get(formik.touched, fieldName, false) &&
      Boolean(get(formik.errors, fieldName, false))
    );
  };

  const getErrorMessage = (fieldName) =>
    get(formik.touched, fieldName, "")
      ? get(formik.errors, fieldName, "") || " "
      : " ";

  useEffect(() => {
    // getContainerList();
    // getLocationList();
    // getGroupList();
    if (id) {
      getServiceDetail();
    }
  }, []);

  return (
    <div>
      <Card
        variant="outlined"
        style={{
          padding: "20px",
          margin: "25px",
          height: "86vh",
          overflow: "auto",
        }}
      >
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          บริการ
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Service
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Service
            </Typography>
          </Grid>
        </Grid>
        <Formik
          enableReinitialize
          initialValues={{
            ServiceName: serviceName ? serviceName : '',
            ServiceNo: serviceNo ? serviceNo : '',
          }}
          onSubmit={(values, { setSubmitting }) => {
            // console.log(values)
            setSubmitting(true);
            const data = {
              ServiceName: values.ServiceName,
              ServiceId: null,
              // from: values.locationFrom,
              // groupFrom: values.groupFrom,
              // to: values.locationTo,
              // groupTo: values.groupTo,
              // priceDate: !values.priceDate
              //   ? moment(new Date()).format("YYYY-MM-DD")
              //   : moment(values.priceDate).format("YYYY-MM-DD"),
              // typeId: values.containerId,
              Status: Status,
              // createId: EmpId,
              // amount: SUM,
              // detail: DetailList.filter((x) => x.Delete === false).map((x) => ({
              //   containerId: x.ContainerId,
              //   amount: x.Amount,
              // })),
            };
            const dataUpdate = {
              ServiceId: id,
              ServiceName: values.ServiceName,
              // from: values.locationFrom,
              // groupFrom: values.groupFrom,
              // to: values.locationTo,
              // groupTo: values.groupTo,
              // priceDate: !values.priceDate
              //   ? moment(new Date()).format("YYYY-MM-DD")
              //   : moment(values.priceDate).format("YYYY-MM-DD"),
              // typeId: values.containerId,
              Status: Status,
              // createId: EmpId,
              // amount: SUM,
              // detail: DetailList.filter((x) => x.Delete === false).map((x) => ({
              //   containerId: x.ContainerId,
              //   amount: x.Amount,
              // })),
            };
            setTimeout(() => {
              if (id) {
                api
                  .post("api/service/update", dataUpdate)
                  .then((respose) => {
                    const MySwal = withReactContent(Swal);

                    MySwal.fire({
                      icon: "success",
                      didOpen: () => {
                        MySwal.clickConfirm();
                      },
                    }).then(() => {
                      return MySwal.fire(
                        "สำเร็จ!",
                        "แก้ไขบริการสำเร็จ !",
                        "success"
                      ).then((result) => {
                        if (result.isConfirmed) {
                          history.push("/Setting/Service");
                        }
                      });
                    });
                    console.log(respose);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              } else {
                api
                  .post("api/service/create", data)
                  .then((respose) => {
                    const MySwal = withReactContent(Swal);

                    MySwal.fire({
                      icon: "success",
                      didOpen: () => {
                        MySwal.clickConfirm();
                      },
                    }).then(() => {
                      return MySwal.fire(
                        "สำเร็จ!",
                        "เพิ่มบริการสำเร็จ !",
                        "success"
                      ).then((result) => {
                        if (result.isConfirmed) {
                          history.push("/Setting/Service");
                        }
                      });
                    });
                    console.log(respose);
                  })
                  .catch((err) => {
                    console.log(err);
                  });

              }

              setSubmitting(false);
            }, 400);
          }}>
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
                เพิ่มบริการใหม่
              </h6>
              <Grid container spacing={2} sx={{ width: { xs: "100%", lg: "50%" } }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    name="ServiceNo"
                    label="Service No."
                    variant="outlined"
                    placeholder="Enter Service No."
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    disabled
                    // onChange={(e) =>
                    //   formik.setFieldValue("ServiceName", e.target.value)
                    // }
                    InputLabelProps={{ shrink: true }}
                    value={values.ServiceNo}
                  // error={isError("ServiceName")}
                  />
                </Grid>
                <Grid item xs={12} md={6}>

                  <TextField
                    required
                    name="ServiceName"
                    label="Service name"
                    variant="outlined"
                    placeholder="Enter Service name"
                    
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    onChange={(e) =>
                      setFieldValue("ServiceName", e.target.value)
                    }
                    InputLabelProps={{ shrink: true }}
                    value={values.ServiceName}
                    error={isError("ServiceName")}
                    classes={{ root: !values.ServiceName ? classes.customOutline : null }}

                  />

                </Grid>

                {/* <Grid item xs={12} md={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd MMM yyyy"
                  name="priceDate"
                  value={
                    formik.values.priceDate
                      ? formik.values.priceDate
                      : new Date()
                  }
                  onChange={(newValue) => {
                    formik.setFieldValue("priceDate", newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="วันที่เริ่มใช้"
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                        width: "100%",
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid> */}
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel id="select_status-label">Status</InputLabel>
                    <Select
                      name="select_status"
                      id="select_status"
                      value={Status}
                      label="Status"
                      style={{
                        width: "100%",
                        // marginTop: "10px",
                        // marginBottom: "10px",
                      }}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <MenuItem value={true}>Active</MenuItem>
                      <MenuItem value={false}>InActive</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              {/* <Grid container spacing={2} sx={{ width: { xs: "100%", lg: "50%" } }}>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="locationFrom">ต้นทาง</InputLabel>
                <Select
                  name="locationFrom"
                  id="locationFrom"
                  value={formik.values.locationFrom}
                  label="ต้นทาง"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  error={isError("locationFrom")}
                  onChange={formik.handleChange}
                >
                  {LocationList.map((data) => (
                    <MenuItem value={data.LocationId}>
                      {data.LocationName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="groupFrom">ประเภทการขนส่ง-ต้นทาง</InputLabel>
                <Select
                  name="groupFrom"
                  id="groupFrom"
                  value={formik.values.groupFrom}
                  label="ประเภทการขนส่ง-ต้นทาง"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  onChange={formik.handleChange}
                  error={isError("groupFrom")}
                >
                  {GroupList.map((data) => (
                    <MenuItem value={data.GroupId}>{data.GroupName}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="select_status-label">ปลายทาง</InputLabel>
                <Select
                  name="locationTo"
                  id="locationTo"
                  value={formik.values.locationTo}
                  label="ต้นทาง"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  onChange={formik.handleChange}
                  error={isError("locationTo")}
                >
                  {LocationList.map((data) => (
                    <MenuItem value={data.LocationId}>
                      {data.LocationName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="groupTo">ประเภทการขนส่ง-ปลายทาง</InputLabel>
                <Select
                  name="groupTo"
                  id="groupTo"
                  value={formik.values.groupTo}
                  label="ประเภทการขนส่ง-ต้นทาง"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  onChange={formik.handleChange}
                  error={isError("groupTo")}
                >
                  {GroupList.map((data) => (
                    <MenuItem value={data.GroupId}>{data.GroupName}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid> */}
              {/* <Grid
            item
            xs
            sx={{ justifyContent: "end", display: "flex", marginTop: 2 }}
          >
            {DetailList.length <= 0 && (
              <p style={{ color: "red", margin: 5 }}>** Please Add Row **</p>
            )}
            <Button
              variant="contained"
              style={{
                background: "#80c340",
                borderColor: "#80c340",
              }}
              onClick={() => setOpen(true)}
            >
              + Add Row
            </Button>
          </Grid> */}
              {/* <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="responsive-dialog-title"
            maxWidth="sm"
            fullWidth={true}
          >
            <DialogTitle id="Price-dialog-title">
              {
                <Typography
                  className="textcolordarkblue"
                  variant="h5"
                  component="h1"
                >
                  ค่าบริการต่อตู้
                </Typography>
              }
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel id="container">ประเภทตู้</InputLabel>
                    <Select
                      name="containerId"
                      id="container"
                      value={ContainerId}
                      label="ประเภทตู้"
                      style={{
                        width: "100%",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      onChange={(e, newValue) => {
                        setContainerId(e.target.value);
                        setContainerName(newValue.props.children);
                      }}
                    >
                      {ContainerList?.filter(
                        ({ ContainerTypeId }) =>
                          !DetailList?.map((x) => x.ContainerId).includes(
                            ContainerTypeId
                          )
                      ).map((data) => (
                        <MenuItem value={data.ContainerTypeId}>
                          {data.ContainerTypeName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    type="number"
                    name="amount"
                    label="ค่าบริการ/ตู้"
                    variant="outlined"
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={Amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center" }}>
              <Button
                sx={{ width: 80 }}
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={() => handleCloseDialog()}
              >
                close
              </Button>
              <Button
                sx={{ width: 80 }}
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                disabled={!ContainerId || !Amount}
                onClick={() => handleSaveDialog()}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>

          {DetailList.length > 0 && (
            <TableContainer
              sx={{
                marginTop: 2,
                marginBottom: 2,
                maxHeight: "35vh",
                height: "35vh",
                overflow: "auto",
              }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">#</TableCell>
                    <TableCell align="center">บริการ</TableCell>
                    <TableCell align="center">ค่าบริการ/ตู้</TableCell>
                    <TableCell align="center"> </TableCell>
                  </TableRow>
                </TableHead>
                {DetailList?.map((data, index) => {
                  return (
                    <TableBody>
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell align="center">
                        {data.ContainerTypeName}
                      </TableCell>
                      <TableCell align="center">{data.Amount}</TableCell>
                      <TableCell align="center">
                        <Button
                          variant="outlined"
                          style={{
                            color: "#FF0000",
                            borderColor: "#FF0000",
                          }}
                          onClick={() => handleDeleteRow(data, index)}
                        >
                          ลบ
                        </Button>
                      </TableCell>
                    </TableBody>
                  );
                })}
              </Table>
            </TableContainer>
          )}

          {DetailList.length > 0 && (
            <Grid container spacing={2}>
              <Grid
                item
                xs={7.5}
                md={9}
                sx={{
                  justifyContent: "end",
                  display: "flex",
                  alignItems: "end",
                }}
              >
                <p>รวมค่าบริการ:</p>
              </Grid>
              <Grid item xs={4.5} md={3}>
                <TextField
                  name="ContainerName"
                  variant="filled"
                  disabled
                  InputProps={{
                    disableUnderline: true,
                  }}
                  sx={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                    color: "red",
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={parseInt(SUM, 10)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                />
              </Grid>
            </Grid>
          )} */}

              <Grid item sx={{ marginTop: 10 }}>
                <Button
                  sx={{ width: 80 }}
                  type="button"
                  variant="outlined"
                  style={{
                    color: "#80c340",
                    borderColor: "#80c340",
                    marginRight: "10px",
                  }}
                  onClick={history.goBack}
                >
                  back
                </Button>
                <Button
                  sx={{ width: 80 }}
                  type="submit"
                  variant="contained"
                  style={{
                    background: "#80c340",
                    borderColor: "#80c340",
                    marginRight: "10px",
                  }}
                //   disabled={Submitting}
                >
                  {Submitting && <CircularProgress size={22} />}
                  {!Submitting && "SAVE"}
                </Button>
              </Grid>
            </form>
          )}
        </Formik>


      </Card>
    </div>
  );
}
